module.exports = __webpack_public_path__ + "img/edit.50a4ff2d.svg";